import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getPropertyPublishInfo } from '../../../../api'
import dayjs from 'dayjs'
import { dateFormat, timeFormat } from './constants'
import PropTypes from 'prop-types'

export const PublishInfo = ({
                              giataId,
                              confirmedImagesCount = 0,
                              confirmedPropertyImagesCount = 0,
                              confirmedRoomImagesCount = 0,
                              factsCount = 0,
                              roomsCount = 0,
                              lastImageUploadDate = null,
                            }) => {
  const [propertyPublishDate, setPropertyPublishDate] = useState(null)
  const [propertyPublishTime, setPropertyPublishTime] = useState(null)
  const [propertyUpdateDate, setPropertyUpdateDate] = useState(null)
  const [propertyUpdateTime, setPropertyUpdateTime] = useState(null)
  const [formattedLastImageUploadDate, setFormattedLastImageUploadDate] = useState(null)
  const { t } = useTranslation()
  useEffect(() => {
    const today = dayjs()
    const yesterday = dayjs().subtract(1, 'day')

    getPropertyPublishInfo(giataId).then(data => {
      if (lastImageUploadDate) {
        const lastImageUpload = dayjs(lastImageUploadDate)
        if (lastImageUpload.isSame(today, 'day')) {
          setFormattedLastImageUploadDate(t('contentMonitor.publishInfo.images.detail.lastUploaded.today'))
        } else if (lastImageUpload.isSame(yesterday, 'day')) {
          setFormattedLastImageUploadDate(t('contentMonitor.publishInfo.images.detail.lastUploaded.yesterday'))
        } else {
          setFormattedLastImageUploadDate(lastImageUpload.format(dateFormat))
        }
      }
      if (!data.updatedAt) {
        return
      }
      const updatedAt = dayjs(data.updatedAt)
      if (updatedAt.isSame(today, 'day')) {
        setPropertyUpdateDate(t('contentMonitor.publishInfo.updatedAt.detail.today'))
      } else if (updatedAt.isSame(yesterday, 'day')) {
        setPropertyUpdateDate(t('contentMonitor.publishInfo.updatedAt.detail.yesterday'))
      } else {
        setPropertyUpdateDate(updatedAt.format(dateFormat))
      }
      setPropertyUpdateTime(updatedAt.format(timeFormat))
      if (!data.publishedAt) {
        return
      }
      const publishedAt = dayjs(data.publishedAt)
      if (publishedAt.isSame(today, 'day')) {
        setPropertyPublishDate(t('contentMonitor.publishInfo.publishedAt.detail.today'))
      } else if (publishedAt.isSame(yesterday, 'day')) {
        setPropertyPublishDate(t('contentMonitor.publishInfo.publishedAt.detail.yesterday'))
      } else {
        setPropertyPublishDate(publishedAt.format(dateFormat))
      }
      setPropertyPublishTime(publishedAt.format(timeFormat))
    })
  }, [giataId, t, lastImageUploadDate])
  if (!propertyUpdateDate) {
    return null
  }
  return <div className="content-monitor-stats-cards">
    <div className="content-monitor-stats-cards__group">
      <div className="content-monitor-stats-cards__card">
        <h2 className="content-monitor-stats-cards__title">
          {t('contentMonitor.publishInfo.images.header')}
        </h2>
        <p className="content-monitor-stats-cards__count">{confirmedImagesCount}</p>
        <p className="content-monitor-stats-cards__detail">
          {t('contentMonitor.publishInfo.images.detail.propertyImages', { count: confirmedPropertyImagesCount })}
        </p>
        <p className="content-monitor-stats-cards__detail">
          {t('contentMonitor.publishInfo.images.detail.roomImages', { count: confirmedRoomImagesCount })}
        </p>
        {
          formattedLastImageUploadDate &&
          <p className="content-monitor-stats-cards__detail content-monitor-stats-cards__detail--bold">
            {t('contentMonitor.publishInfo.images.detail.lastUploaded.date', { date: formattedLastImageUploadDate })}
          </p>
        }
      </div>
      <div className="content-monitor-stats-cards__card">
        <h2 className="content-monitor-stats-cards__title">
          {t('contentMonitor.publishInfo.facts.header')}
        </h2>
        <p className="content-monitor-stats-cards__count">{factsCount}</p>
        <p className="content-monitor-stats-cards__detail">
          {t('contentMonitor.publishInfo.facts.detail')}
        </p>
      </div>
      <div className="content-monitor-stats-cards__card">
        <h2 className="content-monitor-stats-cards__title">
          {t('contentMonitor.publishInfo.rooms.header')}
        </h2>
        <p className="content-monitor-stats-cards__count">{roomsCount}</p>
        <p className="content-monitor-stats-cards__detail">
          {t('contentMonitor.publishInfo.rooms.detail', { count: roomsCount })}
        </p>
      </div>
      <div className="content-monitor-stats-cards__card">
        <h2 className="content-monitor-stats-cards__title">
          {t('contentMonitor.publishInfo.updatedAt.header')}
        </h2>
        <p className="content-monitor-stats-cards__subtitle">
          {propertyUpdateDate}
        </p>
        <p className="content-monitor-stats-cards__detail content-monitor-stats-cards__detail--anchored">
          {propertyUpdateTime}
        </p>
      </div>
    </div>
    <div className="content-monitor-stats-cards__group">
      <div className="content-monitor-stats-cards__card content-monitor-stats-cards__card--last">
        <h2 className="content-monitor-stats-cards__title">
          {t('contentMonitor.publishInfo.publishedAt.header')}
        </h2>
        <p className="content-monitor-stats-cards__subtitle">
          {propertyPublishDate || t('contentMonitor.publishInfo.publishedAt.detail.unpublished')}
        </p>
        <p className="content-monitor-stats-cards__detail content-monitor-stats-cards__detail--anchored">
          {propertyPublishTime}
        </p>
      </div>
    </div>
  </div>
}

PublishInfo.propTypes = {
  giataId: PropTypes.number.isRequired,
  confirmedImagesCount: PropTypes.number,
  confirmedPropertyImagesCount: PropTypes.number,
  confirmedRoomImagesCount: PropTypes.number,
  factsCount: PropTypes.number,
  roomsCount: PropTypes.number,
  lastImageUploadDate: PropTypes.instanceOf(Date),
}

export default PublishInfo
